module.exports = __webpack_public_path__ + "static/media/stocks-3.b0b6841a.jpg";